import { render, staticRenderFns } from "./GoserviceView.vue?vue&type=template&id=a6309362&"
import script from "./GoserviceView.vue?vue&type=script&lang=js&"
export * from "./GoserviceView.vue?vue&type=script&lang=js&"
import style0 from "./GoserviceView.vue?vue&type=style&index=0&id=a6309362&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports